import { Component, Input, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalGalleryComponent } from '../../components/modal-gallery/modal-gallery.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalGalleryCompleteComponent } from '../../components/modal-gallery-complete/modal-gallery-complete.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-galery-img',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './galery-img.component.html',
  styleUrls: ['./galery-img.component.scss']
})
export class GaleryImgComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() title: any[] = [];
  @Input() componentId: string = 'gal-' + Math.random().toString(36).substring(2, 9);

  gallery: any[] = [];
  viewMode: 'grid' | 'carousel' = 'grid';
  currentIndex: number = 0;
  cant: number = 3;
  isDesktop: boolean = true;

  public trustedBody: SafeHtml = '';

  @Input() set body(value: string) {
    console.log(value)
    if (value) {
      this.trustedBody = this.sanitizer.bypassSecurityTrustHtml(value);
    } else {
      this.trustedBody = '';
    }
  }

  constructor(public dialog: MatDialog, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    if (this.data) {
      var i = 0;
      this.data.forEach(element => {
        let img: any = {};
        img.id = element.id;
        img.path = element.path;
        img.pathComplete = element.pathComplete;
        img.position = i;
        i++;
        this.gallery.push(img);
      });
    }
    this.updateResponsiveConfig();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateResponsiveConfig();
  }

  updateResponsiveConfig() {
    this.isDesktop = window.innerWidth > 992;
    this.cant = this.isDesktop ? 3 : 1;
    if (this.currentIndex > this.gallery.length - this.cant) {
      this.currentIndex = Math.max(0, this.gallery.length - this.cant);
    }
  }

  get carouselTransform(): string {
    const step = 100 / this.cant;
    return `translateX(-${this.currentIndex * step}%)`;
  }

  get lockedLeft(): boolean { return this.currentIndex === 0; }
  get lockedRight(): boolean { return this.currentIndex >= this.gallery.length - this.cant; }

  moveLeft() { if (!this.lockedLeft) this.currentIndex--; }
  moveRight() { if (!this.lockedRight) this.currentIndex++; }

  setView(mode: 'grid' | 'carousel') {
    this.viewMode = mode;
    this.currentIndex = 0;
  }

  openModal(id: number): void {
    this.dialog.open(ModalGalleryCompleteComponent, {
      width: '95vw',
      height: '90vh',
      maxWidth: '1200px',
      panelClass: 'full-screen-modal',
      data: { titulo: this.title, gallery: this.gallery, id: id }
    });
  }
}